"use client";

import type { BuilderContextInterface, RegisteredComponents } from "@builder.io/sdk-react";
import { Blocks } from "@builder.io/sdk-react";

import { useConfig } from "@jti/app-context/useConfig";
import { ImageNavLinksList as UIImageNavLinksList } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/ImageNavLinksList";
import { ImageNavLinksList as MobileFirstUIImageNavLinksList } from "@jti/ui/eva-components/MobileFirstHeader/components/SecondaryNavigation/components/ImageNavLinksList";

import { type imageNavLinksListInputs } from "./ImageNavLinksList.builder";

export type ImageNavLinksListBuilderProps = BuilderComponentProps<typeof imageNavLinksListInputs> & {
  builderContext: BuilderContextInterface;
  builderComponents: RegisteredComponents;
};

export function ImageNavLinksList({
  builderBlock,
  builderContext,
  builderComponents,
  variant,
}: ImageNavLinksListBuilderProps) {
  const { isMobileFirstNavigationEnabled } = useConfig();
  const ImageNavLinksListComponent = isMobileFirstNavigationEnabled
    ? MobileFirstUIImageNavLinksList
    : UIImageNavLinksList;

  return (
    <ImageNavLinksListComponent variant={variant}>
      {builderBlock?.children?.map((child) => (
        <Blocks
          key={child.id}
          blocks={[child]}
          parent={builderBlock?.id}
          path="children"
          context={builderContext}
          registeredComponents={builderComponents}
        />
      ))}
    </ImageNavLinksListComponent>
  );
}
